<template>
    <div class="layout-footer" v-if="!isEndUser">
        <div class="footer-logo-container">
            <img id="footer-logo" src="assets/layout/images/logo-emersion.svg" alt="Nimbus Logo" style="height: 1.5rem; width: auto;"/>
        </div>
        <span class="copyright"> &copy; {{ new Date().getFullYear() }} Copyright Emersion Systems Pty Ltd | All Rights Reserved | <small> {{ version }}</small></span>
    </div>

    <div class="layout-footer" v-else>
        <div class="footer-logo-container">
            <span class="app-name">{{ footerMessage }}</span>
        </div>
        <span class="copyright">Powered by Emersion Systems</span>
    </div>
</template>

<script>
import { useUserStore } from "@/stores/user-store";
import { useEUPStore } from '@/stores/eup-store';
import { computed } from 'vue';
export default {
    name: "AppFooter",
    setup() {
        const version = `V${process.env.VUE_APP_VERSION ?? "1.0.0"}`;

        const userStore = useUserStore();
        const eupStore = useEUPStore();
        const isEndUser = computed(() => userStore.isEup);
        const footerMessage = eupStore.eupSettings.footer_content;

        return {
            version,
            isEndUser,
            footerMessage
        }
    }
};
</script>